import React from "react";
import SelectSituacaoAnalisePVL from "pages/pvl/SelectSituacaoAnalisePVL";
import KskBoxCollapse from "ksk/styledComponents/components/KskBox/KskBoxCollapse";
import KskInputRico from "ksk/styledComponents/components/KskInputRico/KskInputRico";
import KskInputHidden from "ksk/styledComponents/components/KskInputHidden/KskInputHidden";
import useStamper from "localization/useStamper";
import styled from "styled-components";

const ComentarioPadraoStyled = styled.section`
  .ksk-collapse__summary,
  .ksk-collapse__summary:active,
  .ksk-collapse__summary:focus {
    outline: none;
    background-color: white;
  }

  .ksk-collapse__summary:hover {
    background-color: #D9E3F3;
  }

  .ksk-collapse__button {
    margin-top: 0px;
    margin-right: 6px;
  }

  .ksk-collapse__content {
    border-left: 2px solid #1351B4;
    margin-left: 1.0em;
    margin-bottom: 1.0em;
    padding-left: 1.0em;
  }

  .ksk-input-rico {
    padding-top: 1.0em;
  }

  .panel-heading {
    background-color: white;
  }

  .note-editable {
    background-color: white;
  }

  .MuiInput-input:focus-within {
    background-color: white;
  }
`;

const SituacaoStyled = styled.div`
  .fa-circle-check {
    color: green;
  }

  .fa-circle-xmark {
    color: red;
  }

  .fa-hourglass-half {
    color: goldenrod;
  }

  .fa-ban {
    color: dimgray;
  }
`;

const ComentarioPadrao = ({form, detail, index, namePrefix,situacoesUsadas})=>{
  const { Stamp } = useStamper();

  const SelectSituacao =
    <SituacaoStyled>
      <SelectSituacaoAnalisePVL
        form={form}
        name={`${namePrefix}.${index}.situacao`}
        valor={detail.situacao}
        situacoesUsadas={situacoesUsadas}
      />
    </SituacaoStyled>

  const ComentarioPadraoContent =
    <KskInputRico
      label={Stamp("common.comentario")}
      form={form}
      name={`${namePrefix}.${index}.comentario`}
      width="100%"
      height="25vh"
      maxHeight="80vh"
      defaultValue={detail.comentario}
    />

  return (
    <>
      <ComentarioPadraoStyled>
        <KskInputHidden form={form} name={`${namePrefix}.${index}.id`} value={detail.id} />
        <KskBoxCollapse renderTitle={()=>SelectSituacao} initialOpen={detail.id?false:true}>
          {ComentarioPadraoContent}
        </KskBoxCollapse>
      </ComentarioPadraoStyled>
    </>
  )
}

export default ComentarioPadrao;
